<header>
  <div id="filters">
    @if (taxYearOptions) {
    <app-search-dropdown
      label="Select {{ yearLabel }}"
      [formGroup]="searchForm"
      [formCtrl]="taxYear"
      [listOptions]="taxYearOptions"
    ></app-search-dropdown>
    } @if (smartFormTypeOptions) {
    <app-search-dropdown
      label="Select {{ smartFormAlias }} Type"
      [formGroup]="searchForm"
      [formCtrl]="smartFormType"
      [listOptions]="smartFormTypeOptions"
    ></app-search-dropdown>
    }
    <div
      id="go"
      [routerLink]="['/settings', 'smartForm', 'builder']"
      [queryParams]="{
        tab: 'categories',
        taxYear: taxYear?.value?.value,
        smartFormTypeId: smartFormType?.value?.value
      }"
      class="ui primary background button"
      [ngClass]="{ disabled: !smartFormTypeOptions?.length }"
    >
      {{ "settings.go" | transloco }}
    </div>
  </div>
</header>
